import React from "react";

export const Box: React.FunctionComponent<{ className?: string, children: React.ReactElement | React.ReactElement[] }> =
    ({className, children}) => {
        return <div
            className={`bg-light p-3 rounded sl-box-shadow sl-loading-container ${className}`}>
            {children}
        </div>
    };